import { http } from '@/apis/aipass'
import { globalHotelId } from '@/hooks/use-hotel-id'
import { env } from '@/libs/env'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { normalizeSpaceTitle, SpaceReservation, SpaceReservationsResponse } from './space-reservation-types'

function normalizeReservations(
  reservations: Array<Omit<SpaceReservation, 'hotelName'> & { hotelName?: string }>,
): SpaceReservation[] {
  return reservations.map(r => ({
    ...r,
    hotelName: r.hotelName ?? '',
    spaceTitle: normalizeSpaceTitle(r.spaceTitle),
  }))
}

export const fetchSpaceReservations = createAsyncThunk<
  SpaceReservationsResponse,
  void,
  { rejectValue: unknown }
>(
  'space/fetchSpaceReservations',
  async (_, { rejectWithValue }) => {
    try {
      const response = await http<SpaceReservationsResponse>({
        method: 'get',
        url: `${env('BASE_API_V3')}/guest/spaces/reservations`,
        params: { hotelId: globalHotelId() },
      })
      const rawList =
        response.data.reservations ?? []
      return {
        reservations: normalizeReservations(rawList),
      }
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

const spaceReservationsListSlice = createSlice({
  name: 'spaceReservationsList',
  initialState: {
    reservations: [] as SpaceReservationsResponse['reservations'],
    loading: false,
  },
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchSpaceReservations.pending, (state) => {
      state.loading = true
    })
    builder.addCase(fetchSpaceReservations.fulfilled, (state, action) => {
      state.reservations = action.payload.reservations
      state.loading = false
    })
    builder.addCase(fetchSpaceReservations.rejected, (state) => {
      state.loading = false
    })
  },
})

export const spaceReservationsListReducer = spaceReservationsListSlice.reducer
